import React from 'react'
import SupplierFilesBlock from './SupplierFilesBlock'

const SupplierFiles = ({ supplier }) => {
  return (
    <div>
        <h4>Файли</h4>

        <SupplierFilesBlock 
            name='Витяг з ЄДР'
            tableOwnerId={supplier.id}
            type='extract'
        />

        <SupplierFilesBlock 
            name='Статут'
            tableOwnerId={supplier.id}
            type='statute'
        />

        <SupplierFilesBlock 
            name='Наказ про призначення директора'
            tableOwnerId={supplier.id}
            type='appointment_director'
        />

        <SupplierFilesBlock 
            name='Витяг (свідоцтво) ПДВ'
            tableOwnerId={supplier.id}
            type='extract_pdv'
        />

        <SupplierFilesBlock 
            name='Паспорт'
            tableOwnerId={supplier.id}
            type='passport'
        />

        <SupplierFilesBlock 
            name='ІПН'
            tableOwnerId={supplier.id}
            type='ipn'
        />

        <SupplierFilesBlock 
            name='Інше'
            tableOwnerId={supplier.id}
            type='other'
        />

    </div>
  )
}

export default SupplierFiles